import { __assign, __awaiter, __extends, __generator } from "tslib";
import { v4 as uuid } from 'uuid';
import { SdkMessageTypes } from '../constants';
import { externalAuthService } from '../external-auth-service';
import { HostedWebContentAuthSdkService } from '../hosted-web-content-auth-sdk';
import { LogLevel, } from '../interfaces';
import { FrameContexts } from '../messages.interface';
import { BaseAuthenticationMessageHandler } from './base-auth-message-handler';
import { formulateAppMessageResult, logMessageResult } from './messageHandlingUtils';
/**
 * Responsible for handling authentication related message requests.
 */
var AuthenticationMessageHandler = /** @class */ (function (_super) {
    __extends(AuthenticationMessageHandler, _super);
    function AuthenticationMessageHandler(appSdkHost, authenticationService, telemetryService) {
        var _this = _super.call(this, appSdkHost, authenticationService, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.authenticationService = authenticationService;
        _this.telemetryService = telemetryService;
        _this.TAG = 'AuthenticationMessageHandler';
        return _this;
    }
    AuthenticationMessageHandler.prototype.initHandlers = function () {
        var _a;
        _super.prototype.initHandlers.call(this);
        this.registerHandler(SdkMessageTypes.authentication.authenticate, this.handleAuthenticate, {
            errorCallback: this.onAuthenticateError,
        });
        (_a = this.authenticationService) === null || _a === void 0 ? void 0 : _a.addEventListener('onExternalAuthDeeplink', function (event) {
            return externalAuthService.completeAuth(event.data.authId, event.data.result);
        });
    };
    AuthenticationMessageHandler.prototype.handleAuthenticate = function (event, url, width, height, isExternal) {
        return __awaiter(this, void 0, void 0, function () {
            var authMessageId_1, notifySuccess, notifyFailure, getUser, acquireToken, windowAuthService, appContext;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.appDefinition) {
                    authMessageId_1 = event.data.id;
                    notifySuccess = function (data) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            this.appSdkHost.postResponseToApp(authMessageId_1, [true, data]);
                            this.appSdkHost.getLogger().log(LogLevel.Debug, this.TAG, "notifySuccess func: ".concat(authMessageId_1));
                            return [2 /*return*/];
                        });
                    }); };
                    notifyFailure = function (reason) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            this.appSdkHost.postResponseToApp(authMessageId_1, [false, reason]);
                            this.appSdkHost.getLogger().log(LogLevel.Debug, this.TAG, "notifyFailure func: ".concat(authMessageId_1));
                            return [2 /*return*/];
                        });
                    }); };
                    getUser = function () {
                        return _this.authenticationService.getUser();
                    };
                    acquireToken = function (resource, claims, silent) {
                        return _this.authenticationService.acquireToken(resource, claims, silent);
                    };
                    windowAuthService = {
                        getUser: getUser,
                        acquireToken: acquireToken,
                        notifySuccess: notifySuccess,
                        notifyFailure: notifyFailure,
                        externalAuthRedirectUrl: this.authenticationService.externalAuthRedirectUrl,
                        addEventListener: function () { },
                        clearListeners: function () { },
                    };
                    appContext = __assign(__assign({}, this.appSdkHost.getContext()), { app: __assign(__assign({}, this.appSdkHost.getContext().app), { sessionId: uuid(), userClickTime: Date.now() }), page: __assign(__assign({}, this.appSdkHost.getContext().page), { frameContext: FrameContexts.authentication }) });
                    new HostedWebContentAuthSdkService(this.appSdkHost.getHostWindow(), { url: url, width: width, height: height }, this.appDefinition, windowAuthService, appContext, this.appSdkHost.getLogger(), undefined, isExternal);
                }
                return [2 /*return*/, logMessageResult];
            });
        });
    };
    AuthenticationMessageHandler.prototype.onAuthenticateError = function (error, scenario) {
        scenario === null || scenario === void 0 ? void 0 : scenario.fail("Authenticate failed ".concat(error));
        return formulateAppMessageResult([false, error]);
    };
    return AuthenticationMessageHandler;
}(BaseAuthenticationMessageHandler));
export { AuthenticationMessageHandler };
//# sourceMappingURL=auth-message-handler.js.map